const mrcapShopCookieName = 'mrcapShopId';
// Cookie is set to last for 1 year (365 value below)
const date = new Date();
date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
const expires = date.toUTCString();

export function SetShopCookie (shopId: number) {
  document.cookie = `${mrcapShopCookieName}=${shopId};expires=${expires};path=/`;
}

export function GetShopCookie () {
  const value = `; ${document.cookie}`;
  const [junk, cookie] = value.split(`; ${mrcapShopCookieName}=`);

  if (cookie && cookie.length > 1) {
    try {
      let stringCookie = cookie.split(';').shift();
      if (stringCookie) {
        return parseInt(stringCookie, 10);
      }
    } catch { return null; }
  }

  return null;
}